import quotationRequestService from "../../../../services/procurementService/quotationRequestService";
import { CACHE_KEY_QUOTATIONREQUESTS } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QuotationRequestInterface } from "../../../../models/ProcurementModule/QuotationRequest";

interface DeleteQuotationRequest {
  previousQuotationRequest: QuotationRequestInterface[];
  deletedVendor: QuotationRequestInterface | undefined;
}

const useDeleteQuotationRequest = (
  purchaseOrderId: string | undefined,
  page: number,
  pageSize: number
) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the customer to delete
    DeleteQuotationRequest
  >({
    mutationFn: quotationRequestService.Remove,

    onMutate: (quotationRequestId: string) => {
      const previousQuotationRequest =
        queryClient.getQueryData<QuotationRequestInterface[]>([
          CACHE_KEY_QUOTATIONREQUESTS,
          purchaseOrderId,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<QuotationRequestInterface[]>(
        [CACHE_KEY_QUOTATIONREQUESTS, purchaseOrderId, page, pageSize],
        previousQuotationRequest.filter(
          (data) => data.id !== quotationRequestId
        ) // Use statusId to filter
      );

      return {
        previousQuotationRequest,
        deletedVendor: previousQuotationRequest.find(
          (data) => data.id === quotationRequestId
        ),
      };
    },

    onError: (error, quotationRequestId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<QuotationRequestInterface[]>(
        [CACHE_KEY_QUOTATIONREQUESTS, purchaseOrderId, page, pageSize],
        context.previousQuotationRequest
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteQuotationRequest;
